module.exports = __webpack_public_path__ + "static/media/modeling-spoon-leatherworking-tool.2a1d7cd8.webp";